"use strict";
exports.__esModule = true;
var Promise = require("bluebird");
var guards_1 = require("../../guards");
var types_1 = require("../../types");
/**
 * @method createAddNeighbors
 *
 * @memberof module:core
 *
 * @param {Provider} provider - Network provider
 *
 * @return {Function} {@link #module_core.addNeighbors `addNeighbors`}
 */
exports.createAddNeighbors = function (_a) {
    var send = _a.send;
    /**
     * Adds a list of neighbors to the connected IRI node by calling
     * [`addNeighbors`](https://docs.iota.works/iri/api#endpoints/addNeighbors) command.
     * Assumes `addNeighbors` command is available on the node.
     *
     * `addNeighbors` has temporary effect until your node relaunches.
     *
     * @example
     *
     * ```js
     * addNeighbors(['udp://148.148.148.148:14265'])
     *   .then(numAdded => {
     *     // ...
     *   }).catch(err => {
     *     // ...
     *   })
     * ```
     *
     * @method addNeighbors
     *
     * @memberof module:core
     *
     * @param {Array} uris - List of URI's
     * @param {Callback} [callback] - Optional callback
     *
     * @return {Promise}
     * @fulfil {number} Number of neighbors that were added
     * @reject {Error}
     * - `INVALID_URI`: Invalid uri
     * - Fetch error
     */
    return function addedNeighbors(uris, callback) {
        return Promise.resolve(guards_1.validate(guards_1.arrayValidator(guards_1.uriValidator)(uris)))
            .then(function () {
            return send({
                command: types_1.IRICommand.ADD_NEIGHBORS,
                uris: uris
            });
        })
            .then(function (res) { return res.addedNeighbors; })
            .asCallback(callback);
    };
};
//# sourceMappingURL=createAddNeighbors.js.map